import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminFetch } from './admin/useAdminApi';

/**
 * useRentalSubscribe — enroll / cancel recurring auto-pay for a rental kind.
 * On success, invalidates the invoices queries so the rental invoices re-render
 * grayed + "On auto pay" (driven by v_invoices_all.rental_autopay).
 */

interface SubscribeInput {
  customer_id: string;
  rental_kind: 'tank' | 'equipment';
  action: 'enroll' | 'cancel';
  source_qbo_invoice_id?: string;
  amount?: number;
  payment_method_id?: string;
}

interface SubscribeResult {
  ok: true;
  status: string;
}

export function useRentalSubscribe() {
  const qc = useQueryClient();
  return useMutation<SubscribeResult, Error, SubscribeInput>({
    mutationFn: (input) =>
      adminFetch<SubscribeResult>('rental-subscribe', {
        method: 'POST',
        body: JSON.stringify(input),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['invoices'] });
      qc.invalidateQueries({ queryKey: ['rental-subscriptions'] });
    },
  });
}
